import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ChiefOfStaff from '../components/ChiefOfStaff';
import { COS_USER_IDS } from '../cosUsers';

// Mobile Chief of Staff — full-screen. Only the two allowlisted users; anyone else
// is bounced (the /cos endpoints also enforce this server-side).
export default function ChiefOfStaffPage() {
  const navigate = useNavigate();
  const { worker } = useAuth();

  useEffect(() => {
    if (worker && !COS_USER_IDS.includes(worker.id)) navigate('/dashboard', { replace: true });
  }, [worker, navigate]);

  return (
    <div className="page chat-page-full">
      <div style={{ flex: 1, minHeight: 0 }}>
        <ChiefOfStaff onBack={() => navigate('/dashboard')} />
      </div>
    </div>
  );
}
